import { concatMap } from './concatMap';
export function concatMapTo(innerObservable) {
    return concatMap(function () { return innerObservable; });
}
//# sourceMappingURL=concatMapTo.js.map